<template>
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="text-h5">{{ id?'Editar Estado Titulacion':'Registrar Estado Titulacion' }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" sm="5" md="7">
                  <v-text-field v-model.trim="nombre" label="Nombre*" required></v-text-field>
                </v-col>
                <v-col cols="12" sm="7" md="5">
                  <v-text-field v-model.trim="color" label="Color*" required></v-text-field>
                </v-col>
              </v-row>
              <p class="text-center red--text"> {{ msg }} </p>
            </v-container> 
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialog = false">
              Cerrar
            </v-btn>
            <v-btn color="blue darken-1" text @click="registrar()" :disabled="loading">
              guardar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </template>

<script>
import {createEstadoTitulacion,updateEstadoTitulacion} from '../estados_titulaciones.js'
  export default {
    data: () => ({
      dialog: false,
      loading: false,
      msg:'',
      nombre:'',
      color:'',
      id: null,
    }),
    methods:{
      openmodal(edit=null){
        this.nombre = '';
        this.color = '';
        this.id = null;
        if(edit){
          this.nombre = edit.nombre;
          this.color = edit.color;
          this.id = edit.id;
        }
        this.dialog = true;
      },
      async registrar(){
        this.msg = '';
        if(!this.nombre) this.msg = 'falta nombre';
        if(!this.color) this.msg = 'falta color';
        if(this.msg) return;
        let res;
        if(!this.id) res = await createEstadoTitulacion(this,this.nombre,this.color);
        else res = await updateEstadoTitulacion(this,this.nombre,this.color, this.id)
        window.console.log(res);
        if(res.ok){
          this.dialog = false;
          this.$emit('reload')
        }else if (res.errors){
          const er = res.errors[0].message
          this.$root.$notify.show(er,{color:'red',x: 'right'});
        }else{
          this.msg = 'algo salio mal.';
        }
      }
    }
  }
</script>
